export default {
	add: {
		button: 'Create saved search',
		cancel: 'Back to results',
		defaultName: 'Saved search #{count}',
		subtitle: 'Add a saved search to access vehicles that fit your stock profile quickly and manage stock alerts.',
		title: 'Add saved search',
	},
	confirmation: {
		button: 'Continue browsing',
		subtitle:
			'Find your saved search at the top of the filter section. You can  manage your saved searches in your account.',
		title: 'Search saved',
	},
	delete: {
		deleteIt: 'Delete it',
		keepIt: 'Keep it',
		subtitle: 'Deleting this search will also stop any stock alerts.',
		title: 'Delete saved search?',
	},
	empty: {
		browseVehiclesButton: 'Browse vehicles',
		createSavedSearchButton: 'Create saved search',
		steps: {
			receiveAlerts: {
				body: 'New vehicles from your saved searches will be sent as a daily email.',
				title: 'Receive stock alerts',
			},
			saveSearch: {
				body: 'Click save search and give it a memorable name, you will now find your search within saved searches.',
				title: 'Save search',
			},
			setFilters: {
				body: 'Apply filters that match your stock profile in the browse screen.',
				title: 'Set filters',
			},
		},
		title: 'Saved searches',
	},
	form: {
		criteria: 'Criteria',
		dropdown: 'Saved search to edit',
		error: {
			name: {
				duplicate: 'This name already exists',
				maxLength: 'Character limit exceeded',
				required: 'Saved search name is required',
			},
		},
		name: 'Name',
		sendEmailAlert: 'Daily stock alerts',
		sendEmailAlertTooltip: 'Receive a daily email with vehicles matching your filters',
	},
	manage: {
		button: 'Update saved search',
		buttonLegacy: 'Save changes',
		defaultTabName: 'My saved search',
		delete: 'Delete saved search',
		subtitle: 'Edit names and manage stock alerts',
		successMessage: 'Changes saved',
		title: 'Saved searches',
	},
};
